import ContentWrapper from '@oberoninternal/travelbase-website/dist/components/ContentWrapper';
import React, { FC } from 'react';
import styled from 'styled-components';

interface Props {
    webcamUrl: string;
}

const WebcamBlock: FC<React.PropsWithChildren<Props>> = ({ webcamUrl }) => (
    <WebcamContentWrapper>
        <Webcam>
            <StyledIframe src={webcamUrl} frameBorder="0" allowFullScreen />
        </Webcam>
    </WebcamContentWrapper>
);

export default WebcamBlock;

const Webcam = styled.div`
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 30px;
    height: 0;
    overflow: hidden;
`;

const WebcamContentWrapper = styled(ContentWrapper as FC<React.PropsWithChildren<unknown>>)`
    @media screen and (max-width: ${({ theme }) => theme.mediaQueries.m}) {
        padding: 0;
    }
`;

const StyledIframe = styled.iframe`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;
